var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 2.34375H0.71875C0.445312 2.34375 0.25 2.14844 0.25 1.875V0.625C0.25 0.390625 0.445312 0.15625 0.71875 0.15625H17.2812C17.5156 0.15625 17.75 0.390625 17.75 0.625V1.875C17.75 2.14844 17.5156 2.34375 17.2812 2.34375ZM17.2812 8.59375H0.71875C0.445312 8.59375 0.25 8.39844 0.25 8.125V6.875C0.25 6.64062 0.445312 6.40625 0.71875 6.40625H17.2812C17.5156 6.40625 17.75 6.64062 17.75 6.875V8.125C17.75 8.39844 17.5156 8.59375 17.2812 8.59375ZM17.2812 14.8438H0.71875C0.445312 14.8438 0.25 14.6484 0.25 14.375V13.125C0.25 12.8906 0.445312 12.6562 0.71875 12.6562H17.2812C17.5156 12.6562 17.75 12.8906 17.75 13.125V14.375C17.75 14.6484 17.5156 14.8438 17.2812 14.8438Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.df8e494b5fd19f6c9a89d0837492b911.svg";
export { ForwardRef as ReactComponent };